import { EmailTemplateDetails } from "../types/emailTemplateTypes";

export const emailTemplateInitialValues: EmailTemplateDetails = {
  id: "",
  name: "",
  nameEn: "",
  subject: "",
  text: "",
  createdDate: undefined,
  lastUpdateDate: undefined,
  isHtml: true,
  userCreate: "",
  userLastUpdate: "",
  params: "",
};

export const emailTemplateValuesOnView = (template: EmailTemplateDetails) => {
  return template;
};
